import { ComponentRef, EnvironmentInjector, Injectable, createComponent, inject } from '@angular/core';
import { Validators } from '@angular/forms';

import { filter, map } from 'rxjs';

import { InputChoices } from '@camelot/form-model';
import { isNonNullable } from '@camelot/utils';

import { InputChoiceTemplateComponent } from '../../components/mission-input-template/mission-input-template.component';
import { CamMissionsService } from '../missions.service';

export enum EMissionFormFields {
  missionId = 'missionId',
}

type ParamsFields = {
  label?: string;
};
@Injectable({
  providedIn: 'root',
})
export class CamMissionInputService {
  private _missionsService = inject(CamMissionsService);
  private environmentInjector = inject(EnvironmentInjector);
  private _compRef: ComponentRef<InputChoiceTemplateComponent> | null = null;

  public getMissionInput(value?: string, params?: ParamsFields) {
    const compRef = this._createOrUsed();

    return new InputChoices({
      key: EMissionFormFields.missionId,
      label: params?.label,
      multiple: false,
      withSearch: true,
      advancedSearch$: (search?: string | null, selectedId?: string[]) =>
        this._missionsService.searchMissions$(search, selectedId).pipe(
          filter(isNonNullable),
          map(missions =>
            missions.map(mission => ({
              id: mission.id,
              name: mission.title,
              missionType: mission.type,
              data: mission,
            }))
          )
        ),
      value: value ? [value] : [],
      choiceTemplate: { list: compRef.instance.getTemplate() },
      validators: [Validators.required],
    });
  }

  private _createOrUsed() {
    const hostElement = document.createElement('div');
    document.body.appendChild(hostElement);
    this._compRef = createComponent(InputChoiceTemplateComponent, {
      hostElement: hostElement,
      environmentInjector: this.environmentInjector,
    });

    return this._compRef!;
  }
}
